
document.addEventListener('DOMContentLoaded', function() {
  // Initialize desktop swiper
  const desktopSwiper = new Swiper('.desktop-swiper', {
    // Show 2 slides per view
    slidesPerView: 2,
    spaceBetween: 0,
    loop: false,
    // Enable touch/mouse interactions on desktop
    allowTouchMove: true,
    simulateTouch: true,
    grabCursor: true,
    touchRatio: 1,
    touchAngle: 45,
    threshold: 5,

    // Navigation arrows
    navigation: {
      nextEl: '.product-section__arrow--right',
      prevEl: '.product-section__arrow--left',
    },
    
    // Smooth transitions
    speed: 600,
    effect: 'slide',
    
    // Disable on mobile
    breakpoints: {
      1200: {
        enabled: true,
      },
      0: {
        enabled: false,
      }
    }
  });
  
  // Initialize mobile swiper
  const productSwiper = new Swiper('.product-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    
    // Touch/Swipe settings
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    allowTouchMove: true,
    
    // Smooth transitions
    speed: 300,
    
    // Responsive breakpoints
    breakpoints: {
      1200: {
        enabled: false, // Disable swiper on desktop
      },
      0: {
        enabled: true, // Enable on mobile/tablet
      }
    }
  });
  
  // Initialize thumbnails swiper (mobile only)
  const thumbnailsSwiper = new Swiper('.thumbnails-swiper', {
    // Show multiple thumbnails per view
    slidesPerView: 'auto',
    spaceBetween: 0, // Using CSS margins instead
    loop: false,
    freeMode: true,
    freeModeMomentum: true,
    freeModeMomentumRatio: 0.25,
    freeModeMomentumBounce: false,
    freeModeSticky: false,

    // Touch/Swipe settings
    simulateTouch: true,
    allowTouchMove: true,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    threshold: 5,
    
    // Smooth transitions
    speed: 300,
    
    // Only enable on mobile/tablet
    breakpoints: {
      1200: {
        enabled: false, // Disable on desktop
      },
      0: {
        enabled: true, // Enable on mobile/tablet
      }
    }
  });

  // Related products swiper moved to related-products.liquid

  
  // Thumbnail click functionality
  const thumbnails = document.querySelectorAll('.product-section__thumbnail');
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      // Remove active class from all thumbnails
      thumbnails.forEach(thumb => thumb.classList.remove('product-section__thumbnail--active'));
      // Add active class to clicked thumbnail
      thumbnail.classList.add('product-section__thumbnail--active');
      // Go to corresponding slide in main product swiper
      productSwiper.slideTo(index);
    });
  });
  
  // Update active thumbnail when slide changes
  productSwiper.on('slideChange', () => {
    const activeIndex = productSwiper.activeIndex;
    thumbnails.forEach((thumb, index) => {
      thumb.classList.toggle('product-section__thumbnail--active', index === activeIndex);
    });
  });
  
  // Sync thumbnails swiper with main product swiper
  if (thumbnailsSwiper) {
    productSwiper.on('slideChange', () => {
      const activeIndex = productSwiper.activeIndex;
      // Center the active thumbnail in the thumbnails swiper
      thumbnailsSwiper.slideTo(activeIndex, 300);
    });
  }

  // Dynamic color swatch styles
  function generateColorSwatchStyles() {
    // Get color data from metafields (if available)
    const colorData = window.productColorData || [];
    
    // Create style element if it doesn't exist
    let styleElement = document.getElementById('dynamic-color-styles');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'dynamic-color-styles';
      document.head.appendChild(styleElement);
    }

    let css = '';
    
    // Generate CSS for each color
    colorData.forEach(color => {
      const className = color.label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      const colorValue = color.color || color.value || '#000000';
      
      // Product section swatches
      css += `.product-section__color-swatch--${className} { background-color: ${colorValue}; }\n`;
      
      // Mobile sticky swatches
      css += `.mobile-sticky__dropdown-color-swatch--${className} { background-color: ${colorValue}; }\n`;
      
      // Add border for white/light colors
      if (colorValue === '#ffffff' || colorValue === '#fff' || colorValue.toLowerCase().includes('white')) {
        css += `.product-section__color-swatch--${className} { border: 1px solid #e5e5e5; }\n`;
        css += `.mobile-sticky__dropdown-color-swatch--${className} { border: 1px solid #e5e5e5; }\n`;
      }
    });

    // Add some common fallback colors
    const fallbackColors = [
      { name: 'blue', value: '#5b6f8e' },
      { name: 'pink', value: '#fdb1ef' },
      { name: 'coyote-dust', value: '#6c6c6c' }, // Updated to correct color
      { name: 'black', value: '#000000' },
      { name: 'white', value: '#ffffff' },
      { name: 'red', value: '#dc2626' },
      { name: 'green', value: '#16a34a' },
      { name: 'yellow', value: '#eab308' },
      { name: 'purple', value: '#9333ea' },
      { name: 'orange', value: '#ea580c' },
      { name: 'gray', value: '#6b7280' }
    ];

    fallbackColors.forEach(color => {
      css += `.product-section__color-swatch--${color.name} { background-color: ${color.value}; }\n`;
      css += `.mobile-sticky__dropdown-color-swatch--${color.name} { background-color: ${color.value}; }\n`;
      
      if (color.name === 'white') {
        css += `.product-section__color-swatch--${color.name} { border: 1px solid #e5e5e5; }\n`;
        css += `.mobile-sticky__dropdown-color-swatch--${color.name} { border: 1px solid #e5e5e5; }\n`;
      }
    });

    styleElement.textContent = css;
  }

  // Generate styles on page load
  generateColorSwatchStyles();

  // Sizing table data parser
  function parseSizingData(dataString) {
    if (!dataString || typeof dataString !== 'string') {
      return null;
    }

    try {
      const rows = dataString.split(';').filter(row => row.trim());
      const parsedData = {
        headers: [],
        rows: []
      };

      rows.forEach((row, index) => {
        const [header, ...values] = row.split(':');
        if (header && values.length > 0) {
          const cleanHeader = header.trim();
          const cleanValues = values[0].split(',').map(val => val.trim());
          
          parsedData.headers.push(cleanHeader);
          
          // If this is the first row, initialize the data structure
          if (index === 0) {
            cleanValues.forEach(() => {
              parsedData.rows.push([]);
            });
          }
          
          // Add values to each row
          cleanValues.forEach((value, valueIndex) => {
            if (parsedData.rows[valueIndex]) {
              parsedData.rows[valueIndex].push(value);
            }
          });
        }
      });

      return parsedData;
    } catch (error) {
      console.error('Error parsing sizing data:', error);
      return null;
    }
  }

  // Generate sizing table HTML
  function generateSizingTable(data) {
    if (!data || !data.headers || !data.rows) {
      return '<p>Invalid sizing data format</p>';
    }

    let html = '<div class="product-section__sizing-table-wrapper">';
    html += '<table class="product-section__sizing-table-content">';
    
    // Headers
    html += '<thead><tr>';
    data.headers.forEach(header => {
      html += `<th>${header}</th>`;
    });
    html += '</tr></thead>';
    
    // Rows
    html += '<tbody>';
    data.rows.forEach(row => {
      html += '<tr>';
      row.forEach(cell => {
        html += `<td>${cell}</td>`;
      });
      html += '</tr>';
    });
    html += '</tbody>';
    
    html += '</table></div>';
    return html;
  }

  // Regenerate styles when colors change (for variant switching)
  function updateColorStyles() {
    // Get current color data from the page
    const colorSwatches = document.querySelectorAll('[data-color-value]');
    const colorData = Array.from(colorSwatches).map(swatch => ({
      label: swatch.dataset.colorLabel,
      color: swatch.dataset.colorValue
    }));

    // Update global color data
    window.productColorData = colorData;
    
    // Regenerate styles
    generateColorSwatchStyles();
  }

  // Listen for color changes
  document.addEventListener('click', function(e) {
    if (e.target.closest('.product-section__color-option, .mobile-sticky__dropdown-item')) {
      setTimeout(updateColorStyles, 100);
    }
  });
  
  // Desktop navigation is now handled by Swiper automatically
  
  // Dropdown positioning function
  function positionDropdown(dropdown, menu) {
    const rect = dropdown.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const menuHeight = menu.scrollHeight;
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    
    // Reset positioning
    menu.style.top = '100%';
    menu.style.bottom = 'auto';
    menu.style.transform = 'translateY(0)';
    
    // If not enough space below, position above
    if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
      menu.style.top = 'auto';
      menu.style.bottom = '100%';
      menu.style.transform = 'translateY(0)';
    }
    // If not enough space above or below, limit height and add scroll
    else if (spaceBelow < menuHeight && spaceAbove < menuHeight) {
      const maxHeight = Math.max(spaceBelow, spaceAbove) - 10;
      menu.style.maxHeight = maxHeight + 'px';
      menu.style.overflowY = 'auto';
    }
  }
  
  // Collapsible info functionality
  const infoItems = document.querySelectorAll('.product-section__info-item');
  
  infoItems.forEach(item => {
    const header = item.querySelector('.product-section__info-header');
    const content = item.querySelector('.product-section__info-content');
    const arrow = item.querySelector('.product-section__info-arrow');
    
    // Initially hide content
    content.style.maxHeight = '0';
    content.style.overflow = 'hidden';
    content.style.opacity = '0';

    
    header.addEventListener('click', () => {
      const isOpen = content.style.maxHeight !== '0px';
      
      if (isOpen) {
        // Close
        content.style.maxHeight = '0';
        arrow.style.transform = 'rotate(0deg)';
        item.classList.remove('product-section__info-item--open');
      } else {
        // Open
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
        arrow.style.transform = 'rotate(180deg)';
        item.classList.add('product-section__info-item--open');
      }
    });
  });
  
  // Mobile dropdown functionality
  const dropdowns = document.querySelectorAll('.mobile-sticky__dropdown');
  
  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('.mobile-sticky__dropdown-trigger');
    const menu = dropdown.querySelector('.mobile-sticky__dropdown-menu');
    const items = dropdown.querySelectorAll('.mobile-sticky__dropdown-item');
    
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Close other dropdowns
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('mobile-sticky__dropdown--open');
        }
      });
      
      // Toggle current dropdown
      dropdown.classList.toggle('mobile-sticky__dropdown--open');
      
      // Position dropdown to prevent overflow
      if (dropdown.classList.contains('mobile-sticky__dropdown--open')) {
        positionDropdown(dropdown, menu);
      }
    });
    
    // Handle item selection
    items.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Remove active class from all items
        items.forEach(otherItem => {
          otherItem.classList.remove('mobile-sticky__dropdown-item--active');
        });

        // Add active class to clicked item
        item.classList.add('mobile-sticky__dropdown-item--active');

        // Update trigger text
        const text = item.querySelector('.mobile-sticky__dropdown-text').textContent;
        const triggerText = trigger.querySelector('.mobile-sticky__dropdown-text');
        triggerText.textContent = text;

        // Sync variant selection based on item type
        if (item.hasAttribute('data-color-label')) {
          const label = item.getAttribute('data-color-label');
          const value = item.getAttribute('data-color-value');
          syncColorSelection(label, value);
        } else if (item.hasAttribute('data-option-index') && item.hasAttribute('data-option-value')) {
          const optionIndex = item.getAttribute('data-option-index');
          const value = item.getAttribute('data-option-value');
          syncSizeSelection(value, optionIndex);
        }

        // Close dropdown
        dropdown.classList.remove('mobile-sticky__dropdown--open');
      });
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.mobile-sticky__dropdown')) {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('mobile-sticky__dropdown--open');
      });
    }
  });

  // Reposition dropdowns on window resize
  window.addEventListener('resize', function() {
    dropdowns.forEach(dropdown => {
      if (dropdown.classList.contains('mobile-sticky__dropdown--open')) {
        const menu = dropdown.querySelector('.mobile-sticky__dropdown-menu');
        positionDropdown(dropdown, menu);
      }
    });
  });

  // --- Sync desktop and mobile selectors (color + size) ---
  // Helpers to read product data
  const productVariants = (function() {
    try {
      const el = document.getElementById('product-variants-data');
      if (el) return JSON.parse(el.textContent || '[]');
    } catch (e) {}
    return Array.isArray(window.productVariants) ? window.productVariants : [];
  })();
  const productOptions = Array.isArray(window.productOptions) ? window.productOptions : [];

  function getActiveColorLabel() {
    const active = document.querySelector('.product-section__color-option.product-section__color-option--active');
    return active ? (active.dataset.colorLabel || '') : '';
  }

  function getActiveSizeValueForIndex(optionIndex) {
    const active = document.querySelector(`.product-section__size-option.product-section__size-option--active[data-option-index="${optionIndex}"]`);
    return active ? (active.dataset.optionValue || '') : '';
  }

  function ensureDefaultSelections() {
    // Default color: pick first if none active
    const hasColorUI = document.querySelector('.product-section__color-options');
    if (hasColorUI && !document.querySelector('.product-section__color-option--active')) {
      const firstColor = document.querySelector('.product-section__color-option');
      if (firstColor) {
        const label = firstColor.dataset.colorLabel;
        const value = firstColor.dataset.colorValue;
        syncColorSelection(label, value);
      }
    }

    // Default size: pick first if none active
    const sizeGroups = document.querySelectorAll('.product-section__size-options');
    sizeGroups.forEach(group => {
      const hasActive = group.querySelector('.product-section__size-option--active');
      if (!hasActive) {
        const firstSize = group.querySelector('.product-section__size-option');
        if (firstSize) {
          const value = firstSize.dataset.optionValue;
          const optionIndex = firstSize.dataset.optionIndex;
          syncSizeSelection(value, optionIndex);
        }
      }
    });
  }

  function updateVariantFromUI() {
    if (!productVariants.length) return;
    // Build selected options in the correct order
    const selected = productOptions.map((name, idx) => {
      const lower = (name || '').toString().toLowerCase();
      if (lower === 'color') {
        const color = getActiveColorLabel();
        if (color) return color;
      }
      // Try size or any other option by index
      const val = getActiveSizeValueForIndex(idx);
      if (val) return val;
      // Fallback to the first variant's value for that index
      return productVariants[0] && productVariants[0].options ? productVariants[0].options[idx] : '';
    });

    // Find matching variant
    let variant = productVariants.find(v => Array.isArray(v.options) && v.options.length === selected.length && v.options.every((opt, i) => String(opt) === String(selected[i])));
    if (!variant) {
      // Fallback to first available, then first
      variant = productVariants.find(v => v.available) || productVariants[0];
    }
    if (!variant) return;

    // Update hidden inputs in both desktop and mobile forms
    document.querySelectorAll('.product-section form input[name="id"], .mobile-sticky form input[name="id"]').forEach(input => {
      input.value = variant.id;
    });

    // Update add to bag disabled state
    document.querySelectorAll('.product-section__add-to-bag, .mobile-sticky__add-to-bag').forEach(btn => {
      if (variant.available) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
      }
    });

    // Optionally update prices if Shopify.formatMoney exists
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const moneyFormat = window.Shopify.money_format || '{{amount}}';
        const priceHTML = Shopify.formatMoney(variant.price, moneyFormat);
        const compareHTML = variant.compare_at_price ? Shopify.formatMoney(variant.compare_at_price, moneyFormat) : null;

        const desktopPrice = document.querySelector('.product-section__price');
        if (desktopPrice) {
          if (compareHTML && variant.compare_at_price > variant.price) {
            desktopPrice.innerHTML = `<span class="product-section__price-current">${priceHTML}</span> <s class="product-section__price-compare">${compareHTML}</s>`;
          } else {
            desktopPrice.innerHTML = priceHTML;
          }
        }

        const mobilePrice = document.querySelector('.mobile-sticky__price');
        if (mobilePrice) {
          mobilePrice.textContent = priceHTML.replace(/<[^>]*>/g,'');
        }
      }
    } catch (e) {}
    // Scroll gallery to this variant's featured media (if any)
    scrollToVariantMedia(variant);
  }
  function scrollToVariantMedia(variant) {
    try {
      if (!variant) return;
      const mediaId = variant.featured_media && (variant.featured_media.id || variant.featured_media.media_id);
      if (!mediaId) return;
      const findIndexByMediaId = (containerSelector) => {
        const slides = document.querySelectorAll(`${containerSelector} .swiper-slide`);
        let targetIndex = -1;
        slides.forEach((slide, idx) => {
          if (String(slide.dataset.mediaId) === String(mediaId)) {
            targetIndex = idx;
          }
        });
        return targetIndex;
      };
      const mobileIndex = findIndexByMediaId('.product-swiper');
      if (mobileIndex >= 0 && typeof productSwiper?.slideTo === 'function') {
        productSwiper.slideTo(mobileIndex);
      }
      const desktopIndex = findIndexByMediaId('.desktop-swiper');
      if (desktopIndex >= 0 && typeof desktopSwiper?.slideTo === 'function') {
        desktopSwiper.slideTo(desktopIndex);
      }
    } catch (e) {}
  }
  function syncColorSelection(label, value) {
    // Desktop: set active state and label
    const desktopColorButtons = document.querySelectorAll('.product-section__color-option');
    desktopColorButtons.forEach(btn => {
      const isActive = btn.dataset.colorLabel === label || btn.dataset.colorValue === value;
      btn.classList.toggle('product-section__color-option--active', !!isActive);
    });
    const desktopColorLabel = document.querySelector('.product-section__color-value');
    if (desktopColorLabel && label) {
      desktopColorLabel.textContent = label;
    }

    // Mobile: set active item and trigger text
    const mobileColorItems = document.querySelectorAll('.mobile-sticky__dropdown-item[data-color-label]');
    mobileColorItems.forEach(item => {
      const isActive = item.dataset.colorLabel === label || item.dataset.colorValue === value;
      item.classList.toggle('mobile-sticky__dropdown-item--active', !!isActive);
    });
    const mobileColorTriggerText = document.querySelector('.mobile-sticky__dropdown .mobile-sticky__dropdown-trigger .mobile-sticky__dropdown-text');
    if (mobileColorTriggerText && label) {
      mobileColorTriggerText.textContent = label;
    }
    // After syncing UI, update variant
    updateVariantFromUI();
  }

  function syncSizeSelection(value, optionIndex) {
    // Desktop: set active state and label
    const desktopSizeButtons = document.querySelectorAll('.product-section__size-option');
    desktopSizeButtons.forEach(btn => {
      const matchIndex = typeof optionIndex !== 'undefined' ? String(btn.dataset.optionIndex) === String(optionIndex) : true;
      const isActive = matchIndex && btn.dataset.optionValue === value;
      btn.classList.toggle('product-section__size-option--active', !!isActive);
    });
    const desktopSizeLabel = document.querySelector('.product-section__size-value');
    if (desktopSizeLabel && value) {
      desktopSizeLabel.textContent = value;
    }

    // Mobile: set active item in size dropdown (matched by optionIndex) and trigger text
    const mobileSizeDropdown = document.querySelector(`.mobile-sticky__dropdown .mobile-sticky__dropdown-trigger[data-option-index]`);
    // Update active items across all size items with matching index (usually only one size option exists)
    const mobileSizeItems = document.querySelectorAll('.mobile-sticky__dropdown-item[data-option-index][data-option-value]');
    mobileSizeItems.forEach(item => {
      const indexMatch = typeof optionIndex !== 'undefined' ? String(item.dataset.optionIndex) === String(optionIndex) : true;
      const isActive = indexMatch && item.dataset.optionValue === value;
      item.classList.toggle('mobile-sticky__dropdown-item--active', !!isActive);
    });
    // Update trigger text for the size dropdown
    if (mobileSizeDropdown) {
      const triggerTextEl = mobileSizeDropdown.querySelector('.mobile-sticky__dropdown-text');
      if (triggerTextEl && value) {
        triggerTextEl.textContent = value;
      }
    }
    // After syncing UI, update variant
    updateVariantFromUI();
  }

  // Desktop color button -> sync to mobile
  document.addEventListener('click', function(e) {
    const colorBtn = e.target.closest('.product-section__color-option');
    if (!colorBtn) return;
    const label = colorBtn.dataset.colorLabel;
    const value = colorBtn.dataset.colorValue;
    syncColorSelection(label, value);
  });

  // Desktop size button -> sync to mobile
  document.addEventListener('click', function(e) {
    const sizeBtn = e.target.closest('.product-section__size-option');
    if (!sizeBtn) return;
    const value = sizeBtn.dataset.optionValue;
    const optionIndex = sizeBtn.dataset.optionIndex;
    syncSizeSelection(value, optionIndex);
  });

  // Mobile color item -> sync to desktop
  document.addEventListener('click', function(e) {
    const colorItem = e.target.closest('.mobile-sticky__dropdown-item[data-color-label]');
    if (!colorItem) return;
    const label = colorItem.dataset.colorLabel;
    const value = colorItem.dataset.colorValue;
    syncColorSelection(label, value);
  });

  // Mobile size item -> sync to desktop
  document.addEventListener('click', function(e) {
    const sizeItem = e.target.closest('.mobile-sticky__dropdown-item[data-option-index][data-option-value]');
    if (!sizeItem) return;
    const value = sizeItem.dataset.optionValue;
    const optionIndex = sizeItem.dataset.optionIndex;
    syncSizeSelection(value, optionIndex);
  });

  // Initialize sizing tables
  function initializeSizingTables() {
    const sizingTableContainers = document.querySelectorAll('.product-section__sizing-table-data');
    
    sizingTableContainers.forEach(container => {
      const dataString = container.getAttribute('data-sizing-data');
      if (dataString) {
        const parsedData = parseSizingData(dataString);
        if (parsedData) {
          const tableHTML = generateSizingTable(parsedData);
          container.innerHTML = tableHTML;
        } else {
          container.innerHTML = '<p>Error: Invalid sizing data format</p>';
        }
      }
    });
  }

  // Initialize sizing tables on page load
  initializeSizingTables();

  // Ensure defaults and set correct variant on first load
  ensureDefaultSelections();
  updateVariantFromUI();
});
